const TimeTableStyle = {
  timeSlot: {
    background: "#f7f7f7",
    padding: "0px 0px 0 10px",
    border: "#ff9800 1px solid",
    borderRadius: "5px",
    marginRight: "10px",
  },

  actionButton: {
    padding: "6px 0px 6px 8px",
  },
};

export default TimeTableStyle;
